import type { useProductsStore } from '~~/common/stores/products';

const RETURN_PRODUCT_LIST_HISTORY_SCROLL_ATTEMPT_MAX = 1000;

type ProductId = NonNullable<ReturnType<typeof useProductsStore>['productListHistoryInformation']>['productId'];

/**
 * Each call gets its own attempt counter, so the retry loop of one scroll does
 * not interfere with a later one. On the server it hands back a no-op.
 */
export function createScrollToProductId () {
  if (import.meta.client) {
    let returnProductListHistoryScrollAttempt = 0;
    let returnProductListHistoryScrollSuccess = false;

    return function scrollToProductId (productId: ProductId) {
      if (returnProductListHistoryScrollAttempt >= RETURN_PRODUCT_LIST_HISTORY_SCROLL_ATTEMPT_MAX || returnProductListHistoryScrollSuccess) {
        window.scrollTo(0, 0);
        return;
      }
      const productCard = document.querySelector('.prodPageReturn-' + productId);
      if (productCard) {
        requestAnimationFrame(() => {
          productCard.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
          });
        });
        returnProductListHistoryScrollSuccess = true;
      } else {
        returnProductListHistoryScrollAttempt++;
        setTimeout(() => scrollToProductId(productId), 100);
      }
    };
  } else {
    return function () {};
  }
}
